import { supabase } from '../lib/supabase'

export type SendPushPayload = {
  userId?: string
  tokens?: string[]
  title: string
  body: string
  data?: Record<string, string | number | boolean | null>
  icon?: string
  tag?: string
  broadcast?: boolean
}

export type PushUserWithTokenCount = {
  user_id: string
  count: number
}

async function send(payload: SendPushPayload) {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  const headers = session?.access_token
    ? {
        Authorization: `Bearer ${session.access_token}`,
      }
    : undefined

  const { data, error } = await supabase.functions.invoke('send-push', {
    body: payload,
    headers,
  })
  if (error) throw error
  return data as { success: number; failure: number; invalidTokens?: string[]; sent: number; pruned?: number }
}

async function sendTestPushToCurrentUser() {
  const {
    data: { session },
    error: sessErr,
  } = await supabase.auth.getSession()
  if (sessErr) throw sessErr
  const userId = session?.user?.id
  if (!userId) throw new Error('Usuário não autenticado')

  const { data, error } = await supabase
    .from('push_tokens')
    .select('token')
    .eq('user_id', userId)

  if (error) throw error
  const tokens = (data ?? []).map((r) => r.token).filter(Boolean)
  return send({ tokens, title: 'Teste de notificação', body: 'Se você recebeu, está tudo certo!' })
}

async function sendToUser(userId: string, title: string, body: string, data?: SendPushPayload['data']) {
  return send({ userId, title, body, data })
}

async function broadcast(title: string, body: string, data?: SendPushPayload['data']) {
  return send({ broadcast: true, title, body, data })
}

export default {
  send,
  sendTestPushToCurrentUser,
  sendToUser,
  broadcast,
  async enqueue(userId: string, title: string, body: string, options?: { data?: SendPushPayload['data']; scheduledAt?: string | Date }) {
    const scheduled_at = options?.scheduledAt instanceof Date ? options?.scheduledAt.toISOString() : (options?.scheduledAt || new Date().toISOString())
    const { error } = await supabase.from('notification_queue').insert({
      user_id: userId,
      title,
      body,
      data: options?.data ?? null,
      scheduled_at,
    })
    if (error) throw error
  },
  async listPushUsers(): Promise<PushUserWithTokenCount[]> {
    const {
      data: { session },
    } = await supabase.auth.getSession()

    const headers = session?.access_token
      ? { Authorization: `Bearer ${session.access_token}` }
      : undefined

    const { data, error } = await supabase.functions.invoke('list-push-users', {
      method: 'GET',
      headers,
    })
    if (error) throw error
    return (data?.users ?? []) as PushUserWithTokenCount[]
  },
}
